import React from "react";
import "./Ticket.scss";
import { FiCalendar, FiMapPin } from "react-icons/fi";
import dayjs from "dayjs";
import { FaCheckCircle } from "react-icons/fa";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { isOffert, sumOfWindows } from "../../../helpers/bookingUtils";

const calculateHighPrice = (price) => {
  if (price === 0) return 0;
  return (price - 24) * 2 + 24;
};

const Ticket = (props) => {
  return (
    <div className="Ticket">
      <h1>Sammanfattning</h1>
      <div className="flex mt-4">
        <p>Antal fönster:</p>
        {/* TODO ADD WINDOWS TYPE HERE */}
        <h4>{`${sumOfWindows(props.windows)} x`}</h4>
      </div>
      {props.windowsPages && (
        <div className="flex mt-4">
          <p>Typ av fönsterputs:</p>
          {/* TODO ADD WINDOWS sigit */}
          <h4>{`${props.windowsPages}-sidig`}</h4>
        </div>
      )}
      {props.optional.length > 0 && (
        <div className="flex mt-4">
          <p>Tillval:</p>
          {/* TODO ADD WINDOWS sigit */}
          <div className="text-sm text-main-600 font-semibold">
            {props.optional.join(", ")}
          </div>
        </div>
      )}
      <div className="line" />
      {props.date && (
        <div className="meetingType" style={{ marginTop: 18 }}>
          <FiCalendar />
          <p>{dayjs(props.date).format("D MMM")}</p>
        </div>
      )}
      {props.step === 3 && (
        <div className="meetingType" style={{ marginTop: 18 }}>
          <FiMapPin />
          <p>
            {props.address && props.address + ","} {props.postNumber}{" "}
            {props.ort}
          </p>
        </div>
      )}
      {/* {(props.meetingType || props.date) && <div className="line" />} */}
      <div className="guarantee">
        <div className="flex mt-4 items-center">
          <div className="rectangle" />
          <FaCheckCircle />
          <p>Framkörning och material ingår i priset *</p>
        </div>
      </div>

      <div className="flex mt-4 items-start text-gray-500">
        <AiOutlineInfoCircle className="mr-2 w-11 info-svg" />
        <p className="text-sm">
          Har du fönster som kräver stege eller annan utrustning för att komma
          åt? Välj till det som tillval så kontaktar vi dig med prisuppgift.{" "}
        </p>
      </div>

      {/*  */}
      <div className="price mt-4">
        <div className="flex justify-between items-center mb-4">
          <p className="mt-0 text-sm">Pris utan rut</p>
          <p className="mt-0 text-sm">
            {isOffert(props.windows, props.howOften, props.optional)
              ? "Offert"
              : `${calculateHighPrice(parseInt(props.price))} kr / tllfälle`}
          </p>
        </div>
        <div className="price-flex">
          <div>
            <h2>TOTALT PRIS</h2>
            <p className="mt-2 text-sm" style={{ color: "#4F4E53" }}>
              per tillfälle & efter rut
            </p>
          </div>
          <h2>
            {isOffert(props.windows, props.howOften, props.optional)
              ? "Offert"
              : `${parseInt(props.price)} kr`}
          </h2>
        </div>
        <hr />
        <p className="text-xs" style={{ color: "#4F4E53" }}>
          *Framkörningsavgift ingår i tätbebyggt område.{" "}
        </p>
      </div>
    </div>
  );
};

export default Ticket;
